import React, { Component } from 'react';
import axios from 'axios';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext';
import Swal from 'sweetalert2';
import ReactApexChart from 'react-apexcharts';
import { TextBox, SubmitBtn, TextArea } from "../../Components/InputElements";
import Select from 'react-select';
import { decodeData } from '../../Constants/constants';
const fromOptions = [
    { value: 'First_Half', label: 'First Half' },
    { value: 'Second_Half', label: 'Second Half' },
    { value: 'Full_Day', label: 'Full Day' },

];

const toOptions = [
    { value: 'First_Half', label: 'First Half' },
    { value: 'Second_Half', label: 'Second Half' },
    { value: 'Full_Day', label: 'Full Day' },

];


class OtDetails extends Component {
    static contextType = ConfigContext;

    constructor(props) {
        super(props);
        this.state = {
            employee_leave_id: 0,
            leave_type_id: '',
            leave_category_id: '',
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            fileName: "",
            fileSize: "",
            selectedImage: null,
            loadingList: false,
            postLoading: false,
            leave_type_row: [],
            leave_category_row: [],
            next: false,
            prev: false,
            LeaveRows: [],
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            rows: [],
            employee_info: [],
            salaries: [],
            salaries_statutory: [],
            decodedData: [],
            series: [{
                name: 'OT Hours',
                type: 'column',
                data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160]
            }, {
                name: 'OT Hours',
                type: 'line',
                data: [23, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16]
            }],
            options: {
                chart: {
                    height: 350,
                    type: 'line',
                },
                stroke: {
                    width: [0, 4]
                },
                title: {
                    text: 'OT Monthly Graph'
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [1]
                },
                labels: ['01 Jan 2001', '02 Jan 2001', '03 Jan 2001', '04 Jan 2001', '05 Jan 2001', '06 Jan 2001', '07 Jan 2001', '08 Jan 2001', '09 Jan 2001', '10 Jan 2001', '11 Jan 2001', '12 Jan 2001'],
                xaxis: {
                    type: 'datetime'
                },
                yaxis: [{
                    title: {
                        text: 'OT Hours',
                    },

                }, {
                    opposite: true,
                    title: {
                        text: 'OT Hours'
                    }
                }]
            },



        };
    }

    componentDidMount() {
        this.setState({ loadingList: true }, () => {
            this.GetList();
            // this.GetLeaveTypeList();
            this.GetRemmainingLeaves();
            this.GetCategoryList();
        });
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
          // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
              const queryParams = new URLSearchParams(window.location.search);
              const encodedData = queryParams.get("abs");
              const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
              if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
              }
            } else {
              console.warn("Permissions not yet available. Retrying...");
            }
        }
      }
    GetCategoryList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetLeaveTypeList`, { headers })
            .then((response) => {
                var data = response.data;
                console.log("category", response);
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        leave_category_row: data.data.map((row) => ({
                            value: row.leave_category_id,
                            label: row.leave_name
                        }))
                    }));
                }
            });
    }

    GetLeaveTypeList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetLeaveTypeList`, { params: { leave_category_id: this.state.leave_category_id }, headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        leave_type_row: data.data.map((row) => ({
                            value: row.leave_type_id,
                            label: row.leave_type_name
                        }))
                    }));
                }
            });
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        const employee_id = this.props.params.employee_id
        axios.get(`${apiURL}Employees/GetEmployeeOTLogs`, { params: { limit: this.state.limit, page: this.state.page , employee_id:employee_id}, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }
    GetRemmainingLeaves = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetRemainingLeaves`, { headers }).then((response) => {
            var data = response.data;
            console.log("data>>", data);
            if (response.data.success === true) {
                this.setState({
                    LeaveRows: data.data,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const fileInput = document.getElementById("employee_leave_document");
        const file = fileInput.files[0];


        const formData = new FormData();
        formData.append("employee_leave_document", file);
        formData.append("leave_type_id", this.state.leave_type_id);
        formData.append("employee_leave_from_date", this.state.employee_leave_from_date);
        formData.append("employee_leave_to_date", this.state.employee_leave_to_date);

        const { apiHeaderFile, apiURL } = this.context;
        const headers = apiHeaderFile;

        axios.post(`${apiURL}Employees/CreateApplyLeave`, formData, { headers })
            .then((response) => {
                console.log("response", response);

                Swal.fire({
                    title: `<strong>${response.data.message}</strong>`,
                    icon: "success",
                });

                // Call resetForm after successful submission
                this.resetForm();

                // Resetting the form should be followed by any other necessary actions
                // such as fetching updated data or performing any other tasks

                this.GetList();
            })
            .catch((error) => {
                console.error("Error uploading file:", error);
            });
    };

    resetForm = () => {
        this.setState({
            employee_leave_id: 0,
            leave_type_id: '',
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            fileName: "",
            fileSize: ""
        })

    }



    resetemployee_leave_document = () => {
        // Clear the input value
        const employee_leave_document = document.getElementById("employee_leave_document");
        if (employee_leave_document) {
            employee_leave_document.value = null;
        }
        // Keep the same key for the input
        let randomString = Math.random().toString(36);
        this.setState({
            theInputKey: randomString,
        });
    };

    handleSelectChange = (name, selectedOption) => {

        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const { name, size, type } = file;
            const fileSizeInMB = size / (1024 * 1024);
            const fileExtension = name.split(".").pop().toLowerCase();

            if (
                type.startsWith("image/") &&
                fileExtension.match(/(jpg|jpeg|png)$/)
            ) {
                this.setState({
                    selectedImage: URL.createObjectURL(file),
                    fileName: name,
                    fileSize: `${fileSizeInMB.toFixed(2)} MB`,
                    isValidExcelFile: false,
                    letterhead: [file], // Update letterhead array
                });
            } else {
                this.setState({
                    isValidExcelFile: true,
                });
                console.error("Invalid file type or extension");
            }
        }
    };

    handleDeleteImage = () => {
        this.setState({
            employee_leave_id: 0,
            selectedImage: null,
            fileName: "",
            fileSize: "",
            leave_type_id: '',
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',

        });
        this.resetemployee_leave_document();
    };


    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleSelect = (selectedOption) => {
        this.setState({
            leave_type_id: selectedOption.value
        });
    };

    handleSelectCat = (selectedOption) => {
        this.setState({
            leave_category_id: selectedOption.value
        }, () => {
            // Call GetLeaveTypeList after updating state
            this.GetLeaveTypeList();
        });
    };

    render() {
        const { loadingList, salaries, employee_info, salaries_statutory, LeaveRows } = this.state;

        const options = {
            chart: {
                height: 350,
                type: 'radialBar',
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '62%',
                    }
                },
            },
            labels: ['Leaves'],
            colors: ['#00BFFF']
        };

        return loadingList === true ? (
            <center>Loading...</center>
        ) : (
            <div className='card'>
                <div className='card-body'>
                    <div class="card-header bg-light bg-gradient">
                        <h6 className="card-title mb-0 text-center" >OVER TIME DETAILS</h6>
                    </div>
                    <div className="row">
                        <div className="col-lg-6" >
                            <div className="card-header">
                                <h6 className="card-title mb-0 text-center">OT MONTHLY GRAPH</h6>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div id="chart">
                                        <ReactApexChart options={this.state.options} series={this.state.series} type="line" height={350} />
                                    </div>
                                    <div id="html-dist"></div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="card-header">
                                <h6 className="card-title mb-0 text-center" >OT HISTORY</h6>
                            </div>
                            <div className="card-body">
                                <div data-simplebar style={{ maxHeight: "350px" }}>
                                    <ul className="list-group">
                                        {
                                            this.state.rows.map((row) => {
                                                return <li className="list-group-item">
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <div className="d-flex">
                                                                <div className="flex-shrink-0 avatar-xs">
                                                                    <div className="avatar-title bg-info-subtle text-info rounded fs-4">
                                                                        <i className="ri-alarm-fill " />
                                                                        {/* <i class="ri-alarm-fill"></i> */}
                                                                    </div>
                                                                </div>
                                                                <div className="flex-shrink-0 ms-2">
                                                                    <h6 className="fs-14 mb-0">{row.company_Ot_labels[0].overtime_type}</h6>
                                                                    <small className="text-muted">{row.employee_overtime_date}</small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="flex-shrink-0 fs-3 ">

                                                            <span className='badge rounded-pill bg-success-subtle text-success' ><i className="mdi mdi-clock-plus" /> {row.employee_overtime_hours} <span>hrs</span></span>
                                                            
                                                        </div>
                                                    </div>
                                                </li>
                                            })
                                        }

                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(OtDetails);
